import { Button, Input, Icon } from 'loyal-react'
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive'

const toSeconds = (seconds) => {
  return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)].join(':').replace(/\b(\d)\b/g, '0$1')
}

const ResendBox = ({
  handleSubmitRegister,
  handleBackRecovery,
  handleSendToken,
  handleChange,
  isEnableToken,
  isLookingUpContact,
  emailAddress,
  isHidden,
  token,
  timeLeft,
  error
}) => {
  const isValid = token && token.length > 0

  const handleKeyPress = (e, element) => {
    let inputIndex = element
    const inputOrder = [
      'token',
      'btnContinue'
    ]
    let isDisabled = true

    while (isDisabled) {
      if (inputOrder[inputIndex] === 'btnContinue') {
        isDisabled = false
      } else {
        let input = document.querySelector(`#${inputOrder[inputIndex]}`)
        if (input.getAttribute('disabled') === null || input.getAttribute('disabled') === undefined) {
          isDisabled = false
        } else {
          inputIndex++
        }
      }
    }

    // eslint-disable-next-line no-unused-expressions
    if (e.key === 'Enter') {
      if (inputIndex) {
        e.target.blur()
        document.querySelector(`#${inputOrder[inputIndex]}`) &&
          document.querySelector(`#${inputOrder[inputIndex]}`).focus()
      }
    }
  }

  return (
    <Fragment>
      <div id='box-login' className={`box-login box-recovery-email row pb-4 ${isHidden && 'd-none'}`}>
        <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a
                    id='image-link'
                    href='#'
                    onClick={handleBackRecovery}
                    className='txt-body-sm d-block'
                    aria-label='Voltar'
                    role='button'
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a
                    href='#'
                    onClick={handleBackRecovery}
                    className='txt-body-sm d-block'
                    aria-label='Voltar'
                    role='button'
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>Recuperar acesso</h1>
              <p className='txt-body-sm mb-1'>Um e-mail com um código de verificação acabou de ser enviado para:</p>
              <div>
                <h2 className='custon-outline login-title txt-title-3 color-brand-1 txt-font-body mb-2 h3'>
                  <span className='txt-bold color-brand-1'>{emailAddress}</span>
                </h2>
              </div>
            </div>
          </div>
          <div className='col-12 col-md-12 txt-left mt-2 px-0'>
            <p className='txt-body-sm mb-1'>Por favor, digite o código no campo:</p>
            <div className='row'>
              <Input
                id='token'
                name='token'
                label='Código de Confirmação'
                className='col-12 col-md-12 mt-1'
                onChange={handleChange}
                onKeyPress={(e) => handleKeyPress(e, 1)}
                value={token}
                valid={error ? false : undefined}
                data-error={error && error.message}
                mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
              />
            </div>
          </div>

          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <div className='hide-absolute' aria-live='assertive' role='status' aria-atomic='true'>
              {!isValid && 'Token inválido, por favor digite um token válido ou reenvie um novo'}
            </div>
            <Button
              id='btnContinue'
              className='btn btn-sm btn-featured'
              type='button'
              text='Continuar'
              disabled={!isValid}
              loading={isLookingUpContact}
              onClick={handleSendToken}
            />
          </div>
          <div className='col-12 col-md-12 txt-center mt-2 px-0'>
            <Button
              className='btn btn-sm'
              id='resend-token'
              type='button'
              text={`${isEnableToken ? 'Reenviar em 00:' + toSeconds(timeLeft) : 'Reenviar Token'}`}
              disabled={isEnableToken}
              onClick={handleSubmitRegister}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}

ResendBox.propTypes = {
  handleSubmitRegister: PropTypes.func.isRequired,
  handleBackRecovery: PropTypes.func.isRequired,
  handleSendToken: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  isEnableToken: PropTypes.bool,
  isLookingUpContact: PropTypes.bool,
  emailAddress: PropTypes.string,
  isHidden: PropTypes.bool,
  token: PropTypes.string,
  timeLeft: PropTypes.string,
  error: PropTypes.string
}

export default ResendBox
